(() => {
  if (window.MQAAARHeroBooted) return;
  window.MQAAARHeroBooted = true;
  const instances = new Map();
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobile = () => window.matchMedia('(max-width: 749px)').matches;

  class MQAAARHero {
    constructor(root) {
      this.root = root;
      this.video = null;
      this.videoObserver = null;
      this.onMediaReady = this.onMediaReady.bind(this);
      this.initMedia();
    }

    initMedia() {
      const image = this.root.querySelector('.mqaar-hero__image');
      if (image) {
        if (image.complete) this.onMediaReady();
        else image.addEventListener('load', this.onMediaReady, { once: true });
        return;
      }

      const preferred = mobile() ? 'mobile' : 'desktop';
      this.video = this.root.querySelector(`[data-mqaar-video="${preferred}"]`)
        || this.root.querySelector('[data-mqaar-video]');
      if (!this.video) {
        this.root.classList.add('is-media-ready');
        return;
      }
      this.video.classList.add('is-active');

      if (reducedMotion()) {
        this.root.classList.add('is-media-ready');
        return;
      }

      this.video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
      });
      this.video.addEventListener('canplay', this.onMediaReady, { once: true });
      this.video.load();
      this.video.play().catch(() => this.onMediaReady());

      if (this.root.dataset.pauseOffscreen === 'true') {
        this.videoObserver = new IntersectionObserver(([entry]) => {
          if (!this.video) return;
          if (entry.isIntersecting) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: 0.05 });
        this.videoObserver.observe(this.root);
      }
    }

    onMediaReady() {
      this.root.classList.add('is-media-ready');
    }

    destroy() {
      this.videoObserver?.disconnect();
      this.video?.pause();
      this.root.querySelector('.mqaar-hero__image')?.removeEventListener('load', this.onMediaReady);
    }
  }

  function mount(scope = document) {
    scope.querySelectorAll('[data-mqaar-hero]').forEach((root) => {
      if (!instances.has(root)) instances.set(root, new MQAAARHero(root));
    });
  }

  function unmount(root) {
    root.querySelectorAll('[data-mqaar-hero]').forEach((hero) => {
      instances.get(hero)?.destroy();
      instances.delete(hero);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => unmount(event.target));
})();
